// Shared hand-off from every lead form to the single /thankyou page.
//
// - The "lead submitted" flag lets /thankyou fire the Google Ads conversion only
//   after a real submission (not on reloads, bookmarks or the old /thank URL).
// - Landing-page forms pass their path as ?from=, which survives reloads and
//   drives the "Back to Previous Page" button and the landing-page layout.

const LEAD_FLAG = 'leadSubmitted'

export function goToThankYou(router, { fromLanding = false } = {}) {
    try {
        sessionStorage.setItem(LEAD_FLAG, '1')
    } catch (_) {}
    const from = fromLanding && typeof window !== 'undefined' ? window.location.pathname : null
    router.push(from ? `/thankyou?from=${encodeURIComponent(from)}` : '/thankyou')
}

// Returns true once per submission, then clears the flag.
export function consumeLeadFlag() {
    try {
        const submitted = sessionStorage.getItem(LEAD_FLAG) === '1'
        sessionStorage.removeItem(LEAD_FLAG)
        return submitted
    } catch (_) {
        return false
    }
}

// Only same-site relative paths are allowed (blocks //host and /\host).
export function safeReturnPath(from) {
    if (typeof from !== 'string') return null
    if (!from.startsWith('/') || from.startsWith('//') || from.startsWith('/\\')) return null
    return from
}
